import * as Backbone from "backbone";
import * as Global from "./global";
import * as UI from "./ui";

export class OnCueRouter extends Backbone.Router {

    constructor() {

        const routerOptions: Backbone.RouterOptions = {
             routes: {
                // tslint:disable:object-literal-sort-keys
                "Logout": "logout",
                ":controller(/:param1)(/:param2)(/:param3)": "loadController",
                "": "defaultRoute",
                "*path": "unknownPage",
                // tslint:enable:object-literal-sort-keys
            },
        };

        super(routerOptions);
    }

    public loadController(controller: string, param1: any, param2: any, param3: any): void {
        // routes in this format:
        //  /controller/[param1]/[param2]/[param3]

        const params: any[] = [];
        if (param1 != null) {params.push(param1); }
        if (param2 != null) {params.push(param2); }
        if (param3 != null) {params.push(param3); }

        // display the requested route
        Global.app().pageManager().displayController(controller, params);
    }

    public defaultRoute(): void {
        Global.app().pageManager().gotoDefaultPage();
    }

    public logout(): void {
        Global.app().pageManager().logout();
    }

    public unknownPage(): void {
        UI.showErrorMessage(["The requested page does not exist."]);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/onCueRouter.ts